
// Use this function to check that all possible variants of a type or an enum are checked.
// Call it on the matched type in the default statement.
// If there is a chance this function is called, the code won't compile, indicating non-exhaustive matching.
export function exhaustiveMatchGuard(_: never): never {
    throw new Error("Didn't expect to get here");
}
